// client/src/services/utilMemberStandards.ts

export interface MsTemplate {
  id: number;
  filename: string;
  title: string;
  category: string;
  active: boolean;
  source?: string;
}

export interface MsState {
  config: MsTemplate[];
  log: string[];
}

export async function fetchState(): Promise<MsState> {
  const r = await fetch('/api/member-standards', { credentials: 'include', cache: 'no-store' });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function seedLibrary(): Promise<{ created: number; active: number; inactive: number }> {
  const r = await fetch('/api/member-standards', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'seed' }),
  });
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error((body as any).error || `HTTP ${r.status}`);
  }
  return r.json();
}

export async function resetRotation(): Promise<void> {
  const r = await fetch('/api/member-standards', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'reset-log' }),
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
}

export async function fetchTemplateHtml(filename: string): Promise<string> {
  const r = await fetch(`/api/member-standards-html?file=${encodeURIComponent(filename)}`, {
    credentials: 'include',
    cache: 'no-store',
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const { html } = await r.json();
  return html as string;
}

export async function saveTemplateHtml(filename: string, html: string): Promise<void> {
  const r = await fetch(`/api/member-standards-html?file=${encodeURIComponent(filename)}`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ html }),
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
}

export async function toggleTemplate(filename: string, active: boolean): Promise<void> {
  const r = await fetch('/api/member-standards-toggle', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename, active }),
  });
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error((body as any).error || `HTTP ${r.status}`);
  }
}

export async function sendTestEmail(filename: string, to?: string): Promise<{ sentTo: string }> {
  const r = await fetch('/api/member-standards-test', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename, ...(to ? { to } : {}) }),
  });
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error((body as any).error || `HTTP ${r.status}`);
  }
  return r.json();
}
